import { map } from 'lodash';
import moment from 'moment';
import { getReferenceDataById } from '../../functions/get-reference-data-by-id';
import { IReferenceData } from '../../interfaces/form/reference-data.model';

export interface IReviewAssessment {
    reviewDate?: string;
    extensionDays?: number;
    reason?: number;
    otherReason?: string;
    asstmtRejectionReason?: number;
    asstmtRejectionReasonOther?: string;
    isApproved?: boolean;
    assessmentType?: string;
    extensionDaysApproved?: number;
    newDueByDate?: string;
    reasonForRejection?: number;
    otherReasonForRejection?: string;
    evalutionName?: string;
    dueDate?: string;
    asstmtReviewApproved?: boolean;
    submittedBy?: string;
}

export interface IRequestExtensionData {
    evaluationSk?: string;
    reviewAssessment?: IReviewAssessment;
    assessmentInformation?: IAssessmentInformationData;
    DueBy?: string;
}

export interface IAssessmentInformationData {
    assessmentDates?: string[];
}

export interface IRequestExtensionReferenceData {
    reason?: IReferenceData[];
}

export class RequestExtensionModel {
    assessmentInformation: AssessmentInformationRequest;
    evaluationSk: string;
    reviewDate: Date;
    extensionDays: number;
    reason: IReferenceData;
    otherReason: string;
    status: number;
    assessmentType: string;
    isApproved: boolean;
    newDueByDate: Date;
    extensionDaysApproved: number;
    otherReasonForRejection: string;
    DueBy: Date;
    reasonForRejection: IReferenceData;
    evalutionName: string;
    dueDate: string;
    asstmtRejectionReasonOther: string;
    asstmtRejectionReason: IReferenceData;
    asstmtReviewApproved: boolean;
    asstmtReviewBy: string;
    asstmtReviewDate: Date;
    submittedBy: string;
    actionStatus: number;

    constructor(data: any, refernceData: any) {
        this.evaluationSk = data?.evaluationSk;
        this.reviewDate = data.reviewAssessment?.reviewDate ? moment(data.reviewAssessment?.reviewDate).toDate() : undefined;
        this.extensionDays = data?.reviewAssessment?.extensionDays;
        this.reason = getReferenceDataById(data?.reviewAssessment?.reason, refernceData.reason);
        this.otherReason = data?.reviewAssessment?.otherReason;
        this.asstmtRejectionReason = getReferenceDataById(data?.reviewAssessment?.asstmtRejectionReason, refernceData.reason);
        this.asstmtRejectionReasonOther = data?.reviewAssessment?.asstmtRejectionReasonOther;
        this.status = 5;
        this.isApproved = data?.reviewAssessment?.isApproved;
        this.assessmentType = data?.reviewAssessment?.assessmentType;
        this.assessmentInformation = new AssessmentInformationRequest(data?.assessmentInformation);
        this.extensionDaysApproved = data?.reviewAssessment?.extensionDaysApproved;
        this.newDueByDate = data.reviewAssessment?.newDueByDate ? moment(data.reviewAssessment?.newDueByDate).toDate() : undefined;
        this.isApproved = data.reviewAssessment?.isApproved
        this.reasonForRejection = getReferenceDataById(data?.reviewAssessment?.reasonForRejection, refernceData.reason);
        this.otherReasonForRejection = data?.reviewAssessment?.otherReasonForRejection;
        this.DueBy = new Date(data?.DueBy);
        this.evalutionName = data?.reviewAssessment?.evalutionName;
        this.dueDate = data?.reviewAssessment?.dueDate
        this.asstmtReviewApproved = data?.reviewAssessment?.asstmtReviewApproved
        this.asstmtReviewBy = data?.reviewAssessment?.asstmtReviewBy;
        this.asstmtReviewDate = data?.reviewAssessment?.asstmtReviewDate ? moment(data?.reviewAssessment?.asstmtReviewDate).toDate() : undefined;
        this.submittedBy = data?.reviewAssessment?.submittedBy;
        this.actionStatus = data?.actionStatus;
    }

    get id(): string {
        return this.evaluationSk
    }
}

export class AssessmentInformationRequest {
    assessmentDates: Date[];

    constructor(data: Partial<IAssessmentInformationData>) {
        this.assessmentDates = map(data?.assessmentDates, (d: string) => moment(d).toDate());
    }
}